import { Box } from '@chakra-ui/react/box'
import { Flex } from '@chakra-ui/react/flex'
import { Image } from '@chakra-ui/react/image'
import { Text } from '@chakra-ui/react/text'

import classes from './styles.module.css'

export interface CarouselItem {
  number: number
  text: string
  image: string
}

interface CarouselProps {
  items: CarouselItem[]
  accentColor: string
}

export function Carousel({ items, accentColor }: CarouselProps) {
  return (
    <Flex className={classes.track}>
      {items.map((item) => (
        <Box key={item.number} className={classes.cardWrapper}>
          <Box className={classes.card}>
            <Flex className={classes.badge} style={{ background: accentColor }}>
              <Text className={classes.badgeNumber}>{item.number}</Text>
            </Flex>
            <Text className={classes.text}>{item.text}</Text>
          </Box>
          <Image src={item.image} alt="" className={classes.image} />
        </Box>
      ))}
    </Flex>
  )
}
